
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remove",
      function () {
        return require("private-next-pages/remove.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remove"])
      });
    }
  